<template>

    <div id="app-container">

        <div class="app-topbar">
            <div class="title-bar">
                <div class="menu-toggle">
                    <a href="#" @click.prevent="menuOpen = !menuOpen">
                        <i class="img icon-menu-white-17" v-if="!menuOpen"></i>
                        <i class="img icon-cross-white-12" v-else></i>
                    </a>
                </div>
                <div class="logo">
                    <a href="#" @click.prevent="navigateHome()">
                        <i class="img logo-aveco-white-36h"></i>
                    </a>
                </div>

                <app-switcher current="mijn-aveco"></app-switcher>

                <div class="user">
                    <div class="user-info">
                        <span>{{ $user.firstName }} {{ $user.lastName }}</span>
                        <a href="#" @click.prevent="logout()">Uitloggen</a>
                    </div>
                    <div class="avatar">{{ $user | userInitials }}</div>
                </div>
            </div>
        </div>

        <div class="app-wrapper">

            <div class="app-sidebar" :class="{ visible: menuOpen }">
                <cms-menu slot="menu">
                    <cms-menu-group title="Menu"></cms-menu-group>
                    <cms-menu-item title="Gebruikers" icon="magicon-user" route="users" v-if="$can('ROUTE_USERS')"></cms-menu-item>
                    <cms-menu-item title="Projecten" icon="magicon-folder-opened" route="projects" v-if="$can('ROUTE_PROJECTS')"></cms-menu-item>
                    <cms-menu-item title="Account" icon="magicon-user" route="account" v-if="$can('ROUTE_ACCOUNT')"></cms-menu-item>
                </cms-menu>
            </div>

            <div class="app-content" @click="menuOpen = false">
                <router-view></router-view>
            </div>

        </div>

        <transition name="fade" :duration="200">
            <div class="cms-shader" v-if="$modal.visible.length" @click="onShaderClick">
                <modal-container class="modal-container" ref="modalContainer"></modal-container>
            </div>
        </transition>

        <toast-container></toast-container>

    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import { isChildOf } from '@wittignl/js-core/directives/clickOutside'
    import AppSwitcher from "app/components/ui/AppSwitcher.vue";

    @Component({

        name: 'app-template',
        components: { AppSwitcher }
    })
    export default class extends Vue
    {

        data() {

            return {

                loading: 0,
                menuOpen: false
            }
        }

        created(){

            // Attach modal service for alerts
            this.$di.alert.attachModalService(this.$modal);

            this.logger = this.$di.logger.child('AppTemplate');
        }

        mounted(){

            this.$watch('$route', () => {
                this.menuOpen = false;
            });
        }

        onShaderClick(e){

            const target = e.target;
            const modalContainer = this.$refs.modalContainer ? this.$refs.modalContainer.$el : null;

            if(modalContainer && isChildOf(modalContainer, target)){

                // Close current modal
                this.$modal.cancelTopModal();
            }
        }

        navigateHome(){

            const route = this.$can('ROUTE_HOME') ? { name: this.$di.config.homeRoute } : { name: 'account' }
            this.$router.push(route);
        }

        logout(){

            this.$auth.logout();
        }
    }

</script>
